import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";

export default function Landing() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col items-center px-4 py-10 sm:py-14">
      <div className="w-full max-w-2xl flex-1 flex flex-col">
        <img
          src="/elevate-logo.png"
          alt="CC Elevate"
          className="h-24 sm:h-28 w-auto mx-auto mb-10 sm:mb-14 select-none"
          draggable={false}
          data-testid="elevate-logo"
        />

        <div className="rise relative gold-frame bg-[hsl(var(--card))] border border-border px-6 sm:px-12 py-12 sm:py-16 text-center">
          <p className="text-[11px] sm:text-xs font-bold tracking-[0.25em] uppercase text-[hsl(var(--accent))]">
            Personal Branding Audit
          </p>
          <p className="mt-6 text-[hsl(var(--accent))] text-sm sm:text-base tracking-[0.15em] uppercase font-semibold">
            Il tuo profilo LinkedIn ti rappresenta davvero?
          </p>
          <h1 className="serif mt-4 text-4xl sm:text-5xl lg:text-6xl leading-tight">
            Quick <span className="text-[hsl(var(--accent))]">Personal Branding</span> Audit
          </h1>
          <p className="mt-6 text-muted-foreground text-sm sm:text-base leading-relaxed max-w-lg mx-auto">
            Rispondi a poche domande sul tuo posizionamento e sul tuo profilo LinkedIn: ricevi
            subito un mini-audit con il tuo profilo ideale, i punti di forza e tre azioni prioritarie.
          </p>
          <div className="mt-6 flex items-center justify-center gap-2 text-[hsl(var(--accent))] text-xs sm:text-sm font-semibold tracking-wide">
            <Clock className="h-4 w-4" />
            <span>Circa 5 minuti &middot; Gratuito &middot; Report immediato</span>
          </div>
          <div className="mt-9">
            <Link
              to="/audit"
              data-testid="start-audit-button"
              className="group inline-flex items-center justify-center gap-2 px-8 py-3.5 text-xs sm:text-sm font-bold tracking-[0.15em] uppercase bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))] transition-transform duration-300 hover:-translate-y-0.5"
            >
              Inizia il tuo Audit
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        <p className="mt-14 text-center text-[10px] tracking-[0.25em] text-muted-foreground uppercase">
          CC-ELEVATE.COM &nbsp;&middot;&nbsp; &copy; 2026 CC Elevate
        </p>
      </div>
    </div>
  );
}
